module.exports = [
    {  
        image: 'https://d1jvd8eenns311.cloudfront.net/prod/images/whereabouts/deryasm7p7kupvuc.jpg',
        loc: { city: "Dubai", country: "United Arab Emirates", 
        latitude: 25.2048493, longitude: 55.270782800000006, region: "Dubai"}    },
    {
        image: 'https://d1jvd8eenns311.cloudfront.net/prod/images/whereabouts/72vxa2rpcurfujs2.jpg',
        loc: { city: "Las Vegas", country: "United States", 
        latitude: 36.1699412, longitude: -115.13982959999998, region: "Nevada"}
    }, 
    {
        image: 'https://d1jvd8eenns311.cloudfront.net/prod/images/whereabouts/a3djeytkwazzpanw.jpg',
        loc: { city: "Paris", country: "France", 
        latitude: 48.856614, longitude: 2.3522219000000177, region: "Ile-de-France"}
    }, 
    { 
        image: 'https://d1jvd8eenns311.cloudfront.net/prod/images/whereabouts/t2zn9ahlt7mekrex.jpg', 
        loc: { city: "New York", country: "United States", 
        latitude: 40.7127753, longitude: -74.0059728, region: "New York"}
    },
    { 
        image: 'https://d1jvd8eenns311.cloudfront.net/prod/images/whereabouts/duvawwvauu4ukr3h.jpg', 
        loc: { city: "Bangkok", country: "Thailand", 
        latitude: 13.7563309, longitude: 100.50176510000006, region: undefined}
    },
    { 
        image: 'https://d1jvd8eenns311.cloudfront.net/prod/images/whereabouts/scde3j6xucfc7zvc.jpg', 
        loc: { city: "London", country: "United Kingdom", 
        latitude: 51.5073509, longitude: -0.12775829999998223, region: "England"}
    },
    { 
        image: 'https://d1jvd8eenns311.cloudfront.net/prod/images/whereabouts/25e5wus9nyhyj4ft.jpg', 
        loc: { city: "Los Angeles", country: "United States", 
        latitude: 34.052235, longitude: -118.243683, region: "California"}
    },
    { 
        image: 'https://d1jvd8eenns311.cloudfront.net/prod/images/whereabouts/r4xvpwa6yp2wzxr4.jpg', 
        loc: { city: "Barcelona", country: "Spain", 
        latitude: 41.3850639, longitude: 2.1734034999999494, region: "Catalonia"}
    },
    { 
        image: 'https://d1jvd8eenns311.cloudfront.net/prod/images/whereabouts/sjrz4pdhjhyvtj2j.jpg', 
        loc: { city: "Miami", country: "United States", 
        latitude: 25.7616798, longitude: -80.19179020000001, region: "Florida"}
    },
    { 
        image: 'https://d1jvd8eenns311.cloudfront.net/prod/images/whereabouts/n5p2s6f3wewt94u6.jpg', 
        loc: { city: "Rome", country: "Italy", 
        latitude: 41.9027835, longitude: 12.496365500000024, region: "Lazio"}
    }            
];


// WEBPACK FOOTER //
// ./src/config/Destinations.js